import React, { useEffect, useState } from "react";
import { FxmsData } from "../datas/FxData";
import { FxLabel } from "./FxLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

/**
 * 기본 MultiSelect 박스
 *
 * @param {function(id, value)} onChangeValue Select박스가 선택되었을 때 호출하는 함수 function(id, value)
 * @param {*} defaultValue 기본값
 * @param {string} name ID 및 이름
 * @param {string} className css명
 * @param {boolean} disabled 비활성화여부
 * @param {number} width 넓이
 * @param {object} datas 목록을 가져올 조건
 * @returns
 */

export const FxMultiSelectBase = props => {
  const { onChangeValue, defaultValue, name, className, disabled, width, datas, selectedData } = props;
  const [ options, setOptions ] = useState([]);
  const [ selectedValue, setSelectedValue ] = useState([]);
  const sx = {};
  const [selectedLabel,setSelectedLabel ] = useState([]);

  // 길이가 정의되어 있으면 지정
  if (width) {
    sx.minWidth = width;
    sx.width = width;
  }

  // Select 박스에 채울 값 가져오기
  useEffect(() => {
    if (datas && datas.type) {
      initOptions(datas.type, datas.para, datas.optionText);
    }
  }, [datas,selectedData]);

  async function initOptions(type, para, optionText) {
    // 조건에 맞는 목록을 가져온다.
    const list = await FxmsData.getSelectItemRt(type, para);

    // 첫 OPTION에 메모 사항이 있으면 넣어준다.
    if (optionText) {
      list.unshift({ key: "", text: optionText });
    }

    // Select박스를 채울 목록을 설정한다.
    setOptions(list);

    // 최초 선택값을 지정한다.
    if (list.length > 0 && selectedData !== undefined) {

      let val = selectedData ? selectedData[name] : null;
      const firstObj = list.find(option => option.key === val[0]);

      if (firstObj !== undefined) {
        setSelectedValue(typeof val === 'string' ? val.split(',') : selectedData[name]);
        onChangeValue(name, val, getObj(val));
        setSelectedLabel(( selectedLabel )=> {
          return [selectedData[name].join(", ")] })
      }
    }
  }

  function getObj(value) {
    if (options) {
      for (let obj of options) {
        if (obj.key === value) {
          return obj.fxObject;
        }
      }
    }
    return null;
  }

  const handleChange = (event) => {
    const { target: { value } } = event;
    setSelectedLabel([]);
    setSelectedValue( typeof value === 'string' ? value.split(',') : value.sort() );
    onChangeValue(event.target.name, event.target.value, getObj(event.target.value));

    for (let i=0; i<value.length; i++){
      const foundObj = options.find(option => option.key === value[i]);
      const found = foundObj ? foundObj.text : '';
      setSelectedLabel((selectedLabel)=> {
        return [...selectedLabel,found]
      })
    };
  };

  return (
    <>
      <FormControl fullWidth>
        <Select className={className ? className : "FxSelect"}
          sx={{width:"100%", color:"white"}}
          multiple
          id={name}
          name ={name}
          onChange={handleChange}
          value={selectedValue}
          MenuProps={{style: {maxHeight: 400}}}
          disabled={disabled}
          renderValue={()=>{
            return(
            <span>
              {selectedLabel.join(", ")}
            </span>
          )}}
        >
          {options.map((option) => (
            <MenuItem key={option.key} value={option.key}>
              <ListItemText sx={{ color :"white"}}
                primary={option.text} />
            </MenuItem>
          ))}

        </Select>
      </FormControl>
    </>
  );

}
